import { PhoneIcon, ShoppingBag, User, Utensils } from 'lucide-react';

import { TableIcon } from '@/components/common/icons/table-icon';
import { useTranslation } from '@/i18n/client';
import { Eat_RestaurantFragment } from '@/lib/__generated__/graphql';

export function CheckoutOrderDetailsSection(props: {
  restaurant: Eat_RestaurantFragment;
  tableNumber: string | null;
  nameOnReceipt: string;
  phoneNumnber: string;
  deliveryDetails: string | null;
  isTegiaMiezPickupTable: boolean;
}) {
  const { t } = useTranslation();

  return (
    <div className="mx-5 my-2 flex flex-col divide-y-1 divide-muted">
      <div className="flex flex-row items-center py-2.5">
        <div className="w-12">
          <Utensils className="size-5" />
        </div>
        <p className="text-md font-medium">{props.restaurant.name}</p>
      </div>

      {props.restaurant.diningMode === 'TABLE' && (
        <div className="flex flex-row items-center py-2.5">
          <div className="-ml-0.5 w-12">
            <TableIcon />
          </div>
          <p className="text-md font-medium">
            {t('Checkout - Table', 'Table')} {props.tableNumber}{' '}
            {props.isTegiaMiezPickupTable && (
              <strong className="block text-pink-600">
                {t(
                  'Tegia Miez - Table needs pickup',
                  'Please pickup your food from the counter 🛍️',
                )}
              </strong>
            )}
          </p>
        </div>
      )}

      {props.restaurant.diningMode !== 'TABLE' && (
        <div className="flex flex-row items-center py-2.5">
          <div className="w-12">
            <PhoneIcon className="size-5" />
          </div>
          <p className="text-md font-medium">{props.phoneNumnber}</p>
        </div>
      )}

      <div className="flex flex-row items-center py-2.5">
        <div className="w-12">
          <User className="size-5" />
        </div>
        <p className="text-md font-medium">{props.nameOnReceipt}</p>
      </div>

      {props.deliveryDetails && (
        <div className="flex flex-row items-center py-2.5">
          <div className="w-12">
            <ShoppingBag className="size-5" />
          </div>
          <p className="text-md font-medium">{props.deliveryDetails}</p>
        </div>
      )}
    </div>
  );
}
